import * as React from 'react';
import { ProgressCircle } from '@mitchell/react.component.ux';
import { StyledOverlayDiv, StyledSpinnerDiv } from './GPCLoaderComponent.style';
export const GPCLoaderComponent = ({ shouldShowLoader, shouldAllowMitchellIntelligent }) => {
    return shouldShowLoader ? (React.createElement(StyledOverlayDiv, { shouldAllowMitchellIntelligent: shouldAllowMitchellIntelligent },
        React.createElement(StyledSpinnerDiv, null,
            React.createElement(ProgressCircle, null)))) : null;
};
//# sourceMappingURL=GPCLoaderComponent.js.map